// extracted by mini-css-extract-plugin
module.exports = {"list":"dropdownNav_list__3YqGN","listItem":"dropdownNav_listItem__2Jbxr","link":"dropdownNav_link__1cTmr"};